export default function validateRegexes(value: any, attributes: { regexes?: { expression: string }[] }) {
  if (!attributes || !attributes.regexes) return true;
  let isValid = true;
  for(let regex of attributes.regexes) {
    const regexObj = new RegExp(regex.expression);
    isValid = regexObj.test(value);
    if(!isValid) break;
  }
  return isValid;
}
